import * as React from "react";
export default {
  play: {
    viewBox: "0 0 40.71 60.72",
    path: (
      <path
        fill="currentColor"
        d="M15.49,1.92l35.4,27.7a2.66,2.66,0,0,1,0,4.76l-35.4,27.7a2.66,2.66,0,0,1-3.85-2.38V4.3A2.66,2.66,0,0,1,15.49,1.92Z"
        transform="translate(-11.64 -1.64)"
      />
    )
  },
  pause: {
    viewBox: "0 0 34 44",
    path: (
      <g>
        <rect fill="currentColor" width="10" height="44" rx="3.89" />
        <rect fill="currentColor" x="24" width="10" height="44" rx="3.89" />
      </g>
    )
  }
};
